export class FrmUtilSADEncode {
    flagEncodDecod: number;
    resultado: string;
    textoEntrada: string;
}

